import { useState } from 'react';

export function useEmailSubscription() {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const subscribeEmail = async (emailToSubscribe, onSuccess, isNewsletter = false) => {
    // Validación de email
    if (!emailToSubscribe || !emailToSubscribe.includes('@')) {
      setSnackbar({
        open: true,
        message: 'Por favor, ingresa un correo válido',
        severity: 'error',
      });
      return false;
    }

    setLoading(true);

    try {
      const isDevelopment = process.env.NODE_ENV === 'development';
      
      let response;
      try {
        response = await fetch('/.netlify/functions/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: emailToSubscribe }),
        });
      } catch (fetchError) {
        if (isDevelopment) {
          console.log('Using mock behavior in development');
          await new Promise((resolve) => setTimeout(resolve, 1000));
          setSnackbar({
            open: true,
            message: isNewsletter ? '¡Gracias por suscribirte!' : '¡Gracias! Te avisaremos cuando esté disponible',
            severity: 'success',
          });
          if (onSuccess) onSuccess();
          setLoading(false);
          return true;
        }
        throw fetchError;
      }

      const data = await response.json();

      if (!response.ok && data.error === 'Service not configured' && isDevelopment) {
        console.log('Service not configured, using mock behavior in development');
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setSnackbar({
          open: true,
          message: isNewsletter ? '¡Gracias por suscribirte!' : '¡Gracias! Te avisaremos cuando esté disponible',
          severity: 'success',
        });
        if (onSuccess) onSuccess();
        setLoading(false);
        return true;
      }

      if (!response.ok) {
        if (response.status === 409) {
          setSnackbar({
            open: true,
            message: 'Este correo ya está registrado',
            severity: 'error',
          });
        } else {
          throw new Error(data.error || 'Error al procesar la solicitud');
        }
      } else {
        setSnackbar({
          open: true,
          message: isNewsletter ? '¡Gracias por suscribirte!' : '¡Gracias! Te avisaremos cuando esté disponible',
          severity: 'success',
        });
        if (onSuccess) onSuccess();
      }
      return true;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log('Error in development, using mock behavior:', error);
        setSnackbar({
          open: true,
          message: isNewsletter ? '¡Gracias por suscribirte!' : '¡Gracias! Te avisaremos cuando esté disponible',
          severity: 'success',
        });
        if (onSuccess) onSuccess();
        return true;
      } else {
        setSnackbar({
          open: true,
          message: 'Hubo un error. Intenta nuevamente',
          severity: 'error',
        });
        return false;
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    snackbar,
    setSnackbar,
    subscribeEmail,
  };
}

